export default __webpack_public_path__ + "media/components/blocks/ExploreAndDiscover/arrow_down-30e3dd30d95e49478369ecfaf7346fc1.png";